/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

export const SET_NOTIFICATIONS = 'notification/SET_NOTIFICATIONS';